import { useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/common/Breadcrumb';
import CSVUpload from '@/components/common/CSVUpload';
import { useToast } from '@/components/common/Toast';
import { ParsedCSVData } from '@/types/upload';
import { validateCouponCsv } from '@/utils/couponCsvValidation';

const CouponUpload = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleUploadSuccess = (_data: ParsedCSVData) => {
    showToast('アップロードを受け付けました。処理状況はアップロード一覧で確認してください');
    navigate('/upload-management/new');
  };

  return (
    <div>
      <Breadcrumb />
      <div className="card max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-admin-text mb-2">クーポンCSVアップロード</h1>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-admin-text mb-2">
            📋 CSVファイルのフォーマットと注意事項
          </h2>
          <ul className="text-sm text-admin-textLight space-y-1 list-disc list-inside">
            <li>
              ファイル形式：CSV形式（.csv）のみ / サイズ 10MB 以下 / 文字コード UTF-8（BOM
              可）または Shift_JIS
            </li>
            <li>
              Book / Product と同じ 3 行構成：1 行目＝カラム名 / 2 行目＝日本語定義名 / 3
              行目以降＝データ（1 行 = 1 クーポン）
            </li>
            <li>
              日時列（start_at / end_at / usable_start_at / usable_end_at）は
              <strong>すべて JST</strong>。形式は 2026/8/1 10:00（日付のみ・タイムゾーン付きは不可）
            </li>
            <li>
              coupon_id は半角英数・ハイフン（-）・アンダースコア（_）の 32 桁。既存 ID を含む CSV
              は上書き更新になる
            </li>
            <li>
              get_type は auto_grant（自動付与）/ user_claim（ユーザーが取得）。user_claim のとき
              get_from_list（0 / 1）必須
            </li>
            <li>
              use_type は all / group / product。all 以外は use_list
              必須（複数はカンマ区切りでダブルクォートで囲む）。all は use_list 空欄。値は product
              なら JDCN（半角英数 20 桁）、group は半角英数・ハイフン・アンダースコアのみ
            </li>
            <li>discount_type は percent（value は 1〜100）/ fixed（value は円・1 以上）</li>
            <li>
              利用期限は usable_period（取得日起算の日数）と usable_start_at / usable_end_at が
              <strong>排他</strong>。すべて空欄なら無期限
            </li>
            <li>usable_count は 1 以上、または -1（無制限）</li>
            <li>buy_now_only と buy_cart_only を両方 1 にはできない</li>
            <li>
              公開状態の列はありません。
              <strong>
                配布を止める場合は同じ coupon_id で end_at を過去日時に変更して再アップロード
              </strong>
              してください（止まるのは新規取得のみ）
            </li>
            <li>1 件でもエラーがあるとその CSV は 1 行も反映されません</li>
          </ul>
        </div>

        <CSVUpload
          uploadType="Coupon"
          customValidate={validateCouponCsv}
          onUploadSuccess={handleUploadSuccess}
        />

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => navigate('/upload-management/new')}
            className="px-6 py-2 border border-gray-300 text-admin-text rounded-lg hover:bg-gray-50 transition-colors"
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default CouponUpload;
